import React from 'react'
import { Image } from 'react-bootstrap';
import about from '../../images/home/product_cat/16001664438222.jpg'

import '../../styles/about.css'

const Dermoroller = () => {
    return (
        <div>
            <h5 className='main-title'>Dermoroller Uygulamaları</h5>
            <hr />
            <p>Derimiz epidermis, dermis ve bağ dokusu olma üzere üç tabakadan oluşur. En üst tabakasının stratum korneum dediğimiz dış katı, yabancı maddelerin derimizden geçişini önler. İlaç, krem, serum gibi maddelerin deriden emilimini ve dolayısıyla tedavi etkisini artırmak için günümüzde ‘mikroiğneleme yöntemi’ kullanılmaya başlanmıştır.</p>
            <Image src={about} fluid className='mb-4' style={{ width: '70%' }} />
            <p>Dermaroller, bir silindir üzerinde sıralanmış mikroiğneleri olan bir tedavi aracıdır. Standart Dermaroller’da 0.1 mm çapında, uzunlukları 0.5 ile 2.0 mm arasında değişebilen, 8 sıra halinde toplam 192 adet mikroiğne bulunur. Bu silindir deri üzerinde hareket ettirilerek mikrokanallar açılır.</p>
            <p>Mikroiğneleme amacıyla kullanılan bir diğer araç da Dermastamp’tır. Dermastamp’te iğneler silindir yerine, dikdörtgen şekilli bir başlık üzerine sıralanmıştır. Dermaroller’a göre daha az sayıda ve daha kısa iğneleri bulunmaktadır. Özellikle saçlı deri uygulamalarında tercih edilir. Dermastamp dikdörtgen şekilli olduğundan, saçların dolanıp kopması önlenmiş olur.</p>
        </div>
    )
}

export default Dermoroller